import {axiosBase, getRequest, postRequest} from "../fetchWrapper";
import axios from "axios";


/*******************************
 ********** Démarches **********
 ******************************/

/**
 * Récupération de la liste des démarches.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getCmsStepList = (token) => {
    const url = `/api-v1/admin/cms/step/list`;
    return getRequest(url, token)
}

/**
 * Récupération des infos d'une étape de démarche.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant de la démarche.
 */
export const getCmsStepInfos = (token, id) => {
    const url = `/api-v1/admin/cms/step/${id}/infos`;
    return getRequest(url, token)
}

/**
 * Modification de l'image d'une étape de démarche.
 *
 * @param token Jeton d'authentification.
 * @param body Corps de la requête.
 * @param id Identifiant du réseau.
 * @return Response | null Réponse de la requête à l'API.
 */
export const uploadCmsStepImage = (token, body, id) => {
    const url = `/api-v1/admin/cms/step/${id}/image/upload`
    return postRequest(url, body, token);
}

/**
 * Modification d'une étape de démarche.
 *
 * @param token Jeton d'authentification.
 * @param body Corps de la requête.
 * @param id Identifiant de la démarche.
 */
export const updateCmsStep = (token, body, id) => {
    const url = `/api-v1/admin/cms/step/${id}/infos`;
    return postRequest(url, body, token);
};

/**
 * Modification du statut d'une étape de démarche.
 *
 * @param string token Jeton d'authentification.
 * @param object body Corps de la requête.
 */
export const updateCmsStepStatus = (token, body) => {
    const url = `/api-v1/admin/cms/step/enable`
    return postRequest(url, body, token)
};

/**
 * Suppression d'une étape de démarche.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de la démarche.
 */
export const deleteCmsStepFromDb = (token, id) => {
    const url = `/api-v1/admin/cms/step/delete`;
    return postRequest(url, id, token)
};

/*******************************
 ******* Mentions légales ******
 ******************************/

/**
 * Récupération de la liste des mentions légales.
 *
 * @param token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getCmsTextList = (categoryId) => {
    const url = `/api-v1/cms/text/${categoryId}/list`;
    return axiosBase(url)
};

/**
 * Récupération des infos d'une mention légale.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de la mention légale.
 */
export const getCmsTextInfos = (token, id) => {
    const url = `/api-v1/admin/cms/text/${id}/infos`;
    return getRequest(url, token)
};

/**
 * Modification d'une mention légale.
 *
 * @param token Jeton d'authentification.
 * @param body Corps de la requête.
 */
export const updateCmsText = (token, body) => {
    const url = `/api-v1/admin/cms/text/update`;
    return postRequest(url, body, token)
};

/**
 * Suppression d'une mention légale.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant de la mention légale.
 */
export const deleteCmsTextFromDb = (token, id) => {
    const url = `/api-v1/admin/cms/text/delete`;
    return postRequest(url, id, token)
};

/**
 * Modification du statut d'une mention légale.
 *
 * @param string token Jeton d'authentification.
 * @param object body Corps de la requête.
 */
export const updateCmsTextStatus = (token, body) => {
    const url = `/api-v1/admin/cms/text/enable`
    return postRequest(url, body, token)
};

/**
 * Déplacer le texte vers le haut.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant du texte.
 */
export const uploadTextPositionUp = (token, id, category) => {
    const url = `/api-v1/admin/cms/text/${category}/${id}/up`;
    return getRequest(url, token)
};

/**
 * Déplacer le texte vers le bas.
 *
 * @param token Jeton d'authentification.
 * @param id Identifiant du texte.
 */
export const uploadTextPositionDown = (token, id, category) => {
    const url = `/api-v1/admin/cms/text/${category}/${id}/down`;
    return getRequest(url, token)
};